import { ANIMATION_DURATION } from '@/constants/register.contants'
import { Box, Button, Fade } from '@mui/material'
import React from 'react'
import { IconReload } from '@tabler/icons-react'

export const ResetButton: React.FC<ResetButtonProps> = ({ onReset }) => {
  return (
    <Fade in={true} timeout={ANIMATION_DURATION}>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'center',
          borderTopWidth: 1,
          borderTopStyle: 'solid',
          borderColor: 'divider',
        }}
      >
        <Button variant="outlined" color="primary" onClick={onReset} startIcon={<IconReload size={16} />}>
          Register again
        </Button>
      </Box>
    </Fade>
  )
}
